import {createBrowserRouter} from 'react-router';
import {authGuard} from '@common/auth/guards/auth-route';
import React, {useEffect} from 'react';
import {authRoutes} from '@common/auth/auth-routes';
import {notificationRoutes} from '@common/notifications/notification-routes';
import {GuestRoute} from '@common/auth/guards/guest-route';
import {RootErrorElement, RootRoute} from '@common/core/common-provider';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {driveRoutes} from '@app/drive/drive-routes';
import {referralRoutes} from '@app/referral/referral-routes';
import {checkoutRoutes} from '@common/billing/checkout/routes/checkout-routes';
import {billingPageRoutes} from '@common/billing/billing-page/routes/billing-page-routes';
import {commonRoutes} from '@common/core/common-routes';
import {adminRoutes} from '@common/admin/routes/admin-routes';

export const appRouter = createBrowserRouter(
  [
    {
      id: 'root',
      element: <RootRoute />,
      errorElement: <RootErrorElement />,
      children: [
        {
          path: '/',
          // The public home page is server-rendered (Blade, routes/web.php).
          // Leave the SPA when navigating to it client-side.
          // Signed-in users keep being sent to their drive, as before.
          element: (
            <GuestRoute>
              <BladeHomepage />
            </GuestRoute>
          ),
        },
        ...referralRoutes,
        ...driveRoutes,
        ...adminRoutes,
        ...authRoutes,
        ...notificationRoutes,
        ...checkoutRoutes,
        ...billingPageRoutes,
        ...commonRoutes,
        {
          path: 'api-docs',
          loader: () =>
            authGuard({permission: 'api.access', requireLogin: false}),
          lazy: () => import('@common/swagger/swagger-api-docs-page'),
        },
      ],
    },
  ],
  {
    basename: getBootstrapData().settings.html_base_uri,
  },
);

// Path the SPA was booted on. If that is already "/", the server rendered the
// SPA for the home page, so reloading would loop: render nothing instead.
const initialPathname =
  typeof window !== 'undefined' ? window.location.pathname : '';

function BladeHomepage() {
  const {base_url} = getBootstrapData().settings;
  useEffect(() => {
    const home = `${base_url.replace(/\/+$/, '')}/`;
    if (new URL(home).pathname !== initialPathname) {
      window.location.assign(home);
    }
  }, [base_url]);
  return null;
}
